/* MKB 2026 — motion layer v5 (immersive + interactive + fluid)
   smooth scroll (Lenis, desktop) · scroll progress (--p) · reveals · word splits · media wipes
   transparent header · sticky Book Now · tilt cards · magnetic buttons · intro curtain · page fade
   custom cursor · mouse parallax · velocity ticker · draggable reel (rubber-band, momentum, keyboard) · live wind · animated FAQ · progress bar · pause control
*/
(function () {
  'use strict';
  var docEl = document.documentElement;
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var design = !!(window.Shopify && window.Shopify.designMode);
  var touch = !!(window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches);
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var lenis = null, io = null, ticking = false, loopOn = false, paused = false;
  var proxy = (typeof WeakMap === 'function') ? new WeakMap() : null;
  var progItems = [], pxItems = [], mouseItems = [], tickers = [], reels = [];
  var cta = null, footer = null, hero = null, heroSticky = false, bar = null;
  var scrollV = 0, lastY = 0, cursor = null;

  docEl.classList.add('mkb-js');
  try { paused = sessionStorage.getItem('mkbPaused') === '1'; } catch (e) {}
  if (paused) docEl.classList.add('mkb-paused');
  function q(root, s) { return Array.prototype.slice.call((root || document).querySelectorAll(s)); }

  /* ---------- smooth scroll ---------- */
  function initLenis() {
    if (lenis || reduce || design || touch || typeof window.Lenis !== 'function') return;
    try {
      lenis = new window.Lenis({
        lerp: 0.085, wheelMultiplier: 1, smoothWheel: true, autoRaf: true, anchors: true,
        prevent: function (node) {
          return !!(node.closest && node.closest('cart-drawer, menu-drawer, header-drawer, .drawer, .facets__display, .facets-container, quick-add-modal, .modal__content, product-modal, [data-lenis-prevent]'));
        }
      });
      docEl.classList.add('mkb-smooth');
      lenis.on('scroll', function (e) { if (e && typeof e.velocity === 'number') scrollV = e.velocity; onScroll(); });
      var sync = function () { if (/overflow-hidden/.test(document.body.className)) lenis.stop(); else lenis.start(); };
      new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    } catch (e) { lenis = null; }
  }

  /* ---------- scroll loop ---------- */
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function frame() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset || 0;
    var vh = window.innerHeight;
    var dy = y - lastY; lastY = y;
    if (!lenis) scrollV = dy;
    var atTop = y <= 24;
    if (atTop !== docEl.classList.contains('mkb-at-top')) {
      docEl.classList.toggle('mkb-at-top', atTop);
      docEl.classList.toggle('mkb-scrolled', !atTop);
    }
    var i, el, r, p, mode;
    for (i = 0; i < progItems.length; i++) {
      el = progItems[i]; mode = el.getAttribute('data-mkb-progress');
      if (mode === 'hero') {
        p = clamp(y / Math.max(1, el.offsetHeight), 0, 1);
      } else {
        r = el.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) continue;
        p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      }
      el.style.setProperty('--p', p.toFixed(4));
    }
    if (!reduce) {
      for (i = 0; i < pxItems.length; i++) {
        el = pxItems[i]; r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) continue;
        var f = parseFloat(el.getAttribute('data-mkb-parallax')) || 0.15;
        var c = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-c * f).toFixed(1) + 'px,0)';
      }
      for (i = 0; i < reels.length; i++) { if (!reels[i].dragging && !paused) reels[i].tx = clamp(reels[i].tx + dy * 0.45, 0, reels[i].max); }
    }
    if (bar) {
      var docH = Math.max(1, docEl.scrollHeight - vh);
      bar.style.transform = 'scaleX(' + clamp(y / docH, 0, 1).toFixed(4) + ')';
    }
    if (cta) {
      var hide = false;
      if (footer) { var fr = footer.getBoundingClientRect(); if (fr.top < vh - 40) hide = true; }
      if (hero) {
        if (heroSticky) { if (y < hero.offsetHeight * 0.62) hide = true; }
        else { var hr = hero.getBoundingClientRect(); if (hr.bottom > vh * 0.6) hide = true; }
      }
      cta.classList.toggle('is-hidden', hide);
    }
  }

  /* ---------- continuous loop (cursor, mouse parallax, ticker, reels) ---------- */
  function rubber(over, dim, k) { k = k || 0.55; return (over * dim * k) / (dim + k * Math.abs(over)); }
  function loop() {
    var i, it;
    scrollV *= 0.9;
    if (cursor) {
      cursor.rx = lerp(cursor.rx, cursor.mx, 0.22); cursor.ry = lerp(cursor.ry, cursor.my, 0.22);
      cursor.dot.style.transform = 'translate3d(' + cursor.mx + 'px,' + cursor.my + 'px,0)';
      cursor.ring.style.transform = 'translate3d(' + cursor.rx.toFixed(1) + 'px,' + cursor.ry.toFixed(1) + 'px,0)' + (cursor.down ? ' scale(.9)' : '');
    }
    for (i = 0; i < mouseItems.length; i++) {
      it = mouseItems[i];
      it.x = lerp(it.x, it.tx, 0.07); it.y = lerp(it.y, it.ty, 0.07);
      it.el.style.setProperty('--mx', it.x.toFixed(3)); it.el.style.setProperty('--my', it.y.toFixed(3));
    }
    if (!paused) {
      var sp = 0.7 + Math.min(Math.abs(scrollV), 80) * 0.12;
      var dir = scrollV < -0.6 ? 1 : -1;
      for (i = 0; i < tickers.length; i++) {
        it = tickers[i];
        if (!it.w) continue;
        it.x += dir * sp;
        if (it.x <= -it.w) it.x += it.w; else if (it.x > 0) it.x -= it.w;
        it.el.style.transform = 'translate3d(' + it.x.toFixed(2) + 'px,0,0)';
      }
    }
    for (i = 0; i < reels.length; i++) {
      it = reels[i];
      if (it.dragging) {
        /* 1:1 with the pointer, rubber-banding past the ends */
        var raw = it.stx - (it.px - it.sx), w = it.el.clientWidth || 1, shown = raw;
        if (raw < 0) shown = rubber(raw, w); else if (raw > it.max) shown = it.max + rubber(raw - it.max, w);
        it.x = shown; it.tx = clamp(raw, 0, it.max);
      } else {
        if (Math.abs(it.v) > 0.05) { it.tx = clamp(it.tx + it.v, 0, it.max); it.v *= 0.95; }
        it.x = lerp(it.x, it.tx, 0.14);
      }
      it.track.style.transform = 'translate3d(' + (-it.x).toFixed(2) + 'px,0,0)';
    }
    requestAnimationFrame(loop);
  }
  function startLoop() { if (!loopOn && !reduce) { loopOn = true; requestAnimationFrame(loop); } }

  /* ---------- reveals ---------- */
  function splitWords(el) {
    if (el.getAttribute('data-mkb-split')) return;
    el.setAttribute('data-mkb-split', '1');
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var i = 0;
    nodes.forEach(function (node) {
      if (!node.nodeValue.trim()) return;
      var frag = document.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var span = document.createElement('span');
        span.className = 'mkb-word';
        span.style.transitionDelay = (i++ * 0.045) + 's';
        span.textContent = part;
        frag.appendChild(span);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }
  function isTarget(el) { return el.classList.contains('mkb-reveal') || el.classList.contains('mkb-words') || el.classList.contains('mkb-media') || el.classList.contains('mkb-reveal-mask'); }
  function autoTag(root) {
    q(root, '.product-grid .grid__item, .collection-list .grid__item, .mkb-pkg, .footer-block, .newsletter__wrapper, .mkb-faq > *, .main-page .rte > :not(.mkb-faq), .product__description > *, .collection-hero__description > *, .mkb-chero__desc, .mkb-reel__item').forEach(function (el, i) {
      if (el.classList.contains('mkb-reveal') || el.classList.contains('mkb-noreveal') || el.classList.contains('mkb-reveal-mask')) return;
      el.classList.add('mkb-reveal');
      if (!el.hasAttribute('data-delay')) el.setAttribute('data-delay', String(i % 4));
    });
    q(root, '.mkb-sv__head h2, .mkb-pkgs__head h2, .collection__title .title, .title-wrapper .title, .collection-hero__title, .main-page-title, .newsletter__title, .footer-block__heading, .product__title h1').forEach(function (el) {
      if (!el.classList.contains('mkb-words') && !el.classList.contains('mkb-nowords')) el.classList.add('mkb-words');
    });
    q(root, '.card__media .media, .product__media, .mkb-pkg__media, .mkb-card__media').forEach(function (el) { el.classList.add('mkb-media'); });
    q(root, '.card-wrapper .card__inner:not([data-mkb-tilt])').forEach(function (el) { el.setAttribute('data-mkb-tilt', '4'); });
    q(root, '.card-wrapper:not([data-cursor])').forEach(function (el) { el.setAttribute('data-cursor', 'View'); });
  }
  function onIntersect(entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var host = e.target;
      var list = proxy ? proxy.get(host) : null;
      if (list) { list.forEach(function (t) { t.classList.add('is-in'); }); proxy.delete(host); }
      if (isTarget(host)) host.classList.add('is-in');
      io.unobserve(host);
    });
  }
  function observe(t) {
    var host = (proxy && t.classList.contains('mkb-media') && t.parentElement) ? t.parentElement : t;
    if (host !== t) { var list = proxy.get(host) || []; list.push(t); proxy.set(host, list); }
    io.observe(host);
  }
  function initReveals(root) {
    root = root || document;
    autoTag(root);
    if (!reduce) q(root, '.mkb-words:not([data-mkb-split])').forEach(splitWords);
    var targets = q(root, '.mkb-reveal:not(.is-in), .mkb-words:not(.is-in), .mkb-media:not(.is-in), .mkb-reveal-mask:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { targets.forEach(function (t) { t.classList.add('is-in'); }); return; }
    if (!io) io = new IntersectionObserver(onIntersect, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    targets.forEach(observe);
  }

  /* ---------- header + hero ---------- */
  function initHeader() {
    var hdr = document.querySelector('.section-header') || document.querySelector('.shopify-section-group-header-group');
    hero = document.querySelector('.mkb-hero, .mkb-chero');
    heroSticky = !!(hero && hero.closest('.mkb-sticky-hero'));
    docEl.classList.toggle('mkb-has-hero', !!document.querySelector('.mkb-under-header'));
    var measure = function () { if (hdr) docEl.style.setProperty('--mkb-header-h', Math.round(hdr.getBoundingClientRect().height) + 'px'); };
    measure(); setTimeout(measure, 500);
    if (!initHeader.bound) { initHeader.bound = true; window.addEventListener('resize', measure); }
  }

  /* ---------- pause control (WCAG: autoplaying motion can be stopped) ---------- */
  function initPause() {
    q(document, '.mkb-pause:not([data-mkb-ready])').forEach(function (btn) {
      btn.setAttribute('data-mkb-ready', '1');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.addEventListener('click', function () {
        paused = !paused;
        docEl.classList.toggle('mkb-paused', paused);
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause'));
        try { sessionStorage.setItem('mkbPaused', paused ? '1' : '0'); } catch (e) {}
      });
      if (paused) btn.setAttribute('aria-label', btn.getAttribute('data-label-play'));
    });
  }

  /* ---------- tilt + magnetic + mouse parallax ---------- */
  function initTilt(root) {
    if (touch || reduce) return;
    q(root, '[data-mkb-tilt]:not([data-mkb-tilt-ready])').forEach(function (el) {
      el.setAttribute('data-mkb-tilt-ready', '1');
      var max = parseFloat(el.getAttribute('data-mkb-tilt')) || 6;
      el.addEventListener('mouseenter', function () { el.classList.add('mkb-tilt-ready'); });
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * max).toFixed(2) + 'deg) rotateY(' + (x * max).toFixed(2) + 'deg) translateY(-6px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }
  function initMagnetic(root) {
    if (touch || reduce) return;
    q(root, '[data-mkb-magnet]:not([data-mkb-magnet-ready])').forEach(function (el) {
      el.setAttribute('data-mkb-magnet-ready', '1');
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - (r.left + r.width / 2), y = e.clientY - (r.top + r.height / 2);
        el.style.transform = 'translate(' + (x * 0.16).toFixed(1) + 'px,' + (y * 0.16).toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }
  function initMouse() {
    if (touch || reduce) return;
    q(document, '[data-mkb-mouse]:not([data-mkb-mouse-ready])').forEach(function (el) {
      el.setAttribute('data-mkb-mouse-ready', '1');
      var it = { el: el, tx: 0, ty: 0, x: 0, y: 0 };
      mouseItems.push(it);
      el.addEventListener('mousemove', function (e) { it.tx = (e.clientX / window.innerWidth - 0.5) * 2; it.ty = (e.clientY / window.innerHeight - 0.5) * 2; }, { passive: true });
      el.addEventListener('mouseleave', function () { it.tx = 0; it.ty = 0; });
    });
    if (mouseItems.length) startLoop();
  }

  /* ---------- custom cursor ---------- */
  function initCursor() {
    if (cursor || touch || reduce || design || !docEl.classList.contains('mkb-cursor')) return;
    var dot = document.createElement('div'); dot.className = 'mkb-cur'; dot.setAttribute('aria-hidden', 'true');
    var ring = document.createElement('div'); ring.className = 'mkb-cur-ring'; ring.setAttribute('aria-hidden', 'true'); ring.innerHTML = '<span class="mkb-cur-ring__label"></span>';
    document.body.appendChild(dot); document.body.appendChild(ring);
    cursor = { dot: dot, ring: ring, mx: -100, my: -100, rx: -100, ry: -100, down: false };
    var label = ring.firstChild;
    document.addEventListener('mousemove', function (e) {
      cursor.mx = e.clientX; cursor.my = e.clientY;
      if (!docEl.classList.contains('mkb-cursor-on')) docEl.classList.add('mkb-cursor-on');
    }, { passive: true });
    document.addEventListener('mouseleave', function () { docEl.classList.remove('mkb-cursor-on'); });
    document.addEventListener('mouseover', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-cursor], a, button, summary, label, [role="button"], input[type="submit"], select, input, textarea') : null;
      var lab = t ? t.getAttribute('data-cursor') : null;
      var isText = t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName);
      ring.classList.toggle('is-link', !!t && !isText);
      ring.classList.toggle('is-label', !!lab);
      ring.classList.toggle('is-text', !!isText);
      label.textContent = lab || '';
    });
    document.addEventListener('pointerdown', function () { cursor.down = true; });
    document.addEventListener('pointerup', function () { cursor.down = false; });
    startLoop();
  }

  /* ---------- ticker + reels ---------- */
  function initTickers() {
    if (reduce) return;
    tickers = q(document, '.mkb-ticker__track').map(function (track) { return { el: track, x: 0, w: 0 }; });
    var measure = function () { tickers.forEach(function (t) { t.w = t.el.scrollWidth / 2; }); };
    measure(); setTimeout(measure, 800);
    if (!initTickers.bound) { initTickers.bound = true; window.addEventListener('resize', measure); }
    if (tickers.length) startLoop();
  }
  function project(v, d) { d = d || 0.998; return (v / 1000) * d / (1 - d); }
  function initReels() {
    if (reduce) return;
    reels = q(document, '[data-mkb-reel]').map(function (el) {
      var track = el.querySelector('.mkb-reel__track');
      var r = { el: el, track: track, x: 0, tx: 0, v: 0, max: 0, dragging: false, sx: 0, stx: 0, px: 0, moved: 0, hist: [] };
      var measure = function () { r.max = Math.max(0, track.scrollWidth - el.clientWidth); r.tx = clamp(r.tx, 0, r.max); };
      measure(); setTimeout(measure, 800); window.addEventListener('resize', measure);
      if (el.getAttribute('data-mkb-reel-ready')) return r;
      el.setAttribute('data-mkb-reel-ready', '1');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        r.dragging = true; r.sx = e.clientX; r.px = e.clientX; r.stx = r.x; r.v = 0; r.moved = 0; r.hist = [[e.clientX, performance.now()]];
        el.classList.add('is-dragging');
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      });
      el.addEventListener('pointermove', function (e) {
        if (!r.dragging) return;
        r.px = e.clientX; r.moved = Math.max(r.moved, Math.abs(e.clientX - r.sx));
        r.hist.push([e.clientX, performance.now()]); if (r.hist.length > 6) r.hist.shift();
      });
      var end = function () {
        if (!r.dragging) return;
        r.dragging = false; el.classList.remove('is-dragging');
        /* release velocity (px/s) from the last few samples, then project the landing point */
        var h = r.hist, vps = 0;
        if (h.length >= 2) { var a = h[0], b = h[h.length - 1]; var dt = Math.max(16, b[1] - a[1]); vps = -(b[0] - a[0]) / dt * 1000; }
        var landing = clamp(r.tx + project(vps), 0, r.max);
        r.v = 0; r.tx = landing;
      };
      el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end); el.addEventListener('lostpointercapture', end);
      el.addEventListener('click', function (e) { if (r.moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { r.tx = clamp(r.tx + 360, 0, r.max); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { r.tx = clamp(r.tx - 360, 0, r.max); e.preventDefault(); }
        else if (e.key === 'Home') { r.tx = 0; e.preventDefault(); }
        else if (e.key === 'End') { r.tx = r.max; e.preventDefault(); }
      });
      return r;
    });
    if (reels.length) startLoop();
  }

  /* ---------- live wind (Open-Meteo, no key) ---------- */
  function initWind() {
    var el = document.querySelector('[data-mkb-wind]:not([data-mkb-wind-ready])');
    if (!el || typeof fetch !== 'function') return;
    el.setAttribute('data-mkb-wind-ready', '1');
    var lat = el.getAttribute('data-lat') || '25.69', lon = el.getAttribute('data-lon') || '-80.16';
    var key = 'mkbWind-' + lat + lon;
    var render = function (d) {
      var kn = Math.round(d.s), gust = Math.round(d.g || 0);
      var compass = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'][Math.round(d.d / 45) % 8];
      var v = el.querySelector('.mkb-wind__val'), dr = el.querySelector('.mkb-wind__dir'), ar = el.querySelector('.mkb-wind__arrow');
      if (v) v.textContent = kn + ' kn' + (gust > kn + 3 ? ' · gusts ' + gust : '');
      if (dr) dr.textContent = compass;
      if (ar) ar.style.transform = 'rotate(' + (d.d + 180) + 'deg)';
      el.setAttribute('aria-label', 'Live wind: ' + kn + ' knots from ' + compass);
      el.classList.add('is-ready');
      el.classList.toggle('is-on', kn >= 12);
    };
    var cached = null; try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < 600000) { render(cached); return; }
    fetch('https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lon + '&current=wind_speed_10m,wind_direction_10m,wind_gusts_10m&wind_speed_unit=kn')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var c = j && j.current; if (!c) return;
        var d = { s: c.wind_speed_10m, g: c.wind_gusts_10m, d: c.wind_direction_10m, t: Date.now() };
        try { sessionStorage.setItem(key, JSON.stringify(d)); } catch (e) {}
        render(d);
      }).catch(function () {});
  }

  /* ---------- animated <details> (FAQ) ---------- */
  function initDetails(root) {
    if (reduce || typeof Element.prototype.animate !== 'function') return;
    q(root, '.mkb-faq details:not([data-mkb-anim])').forEach(function (d) {
      d.setAttribute('data-mkb-anim', '1');
      var s = d.querySelector('summary'); if (!s) return;
      var busy = false;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (busy) return; busy = true;
        var h0 = d.offsetHeight, ease = 'cubic-bezier(.22,1,.36,1)';
        d.style.overflow = 'hidden';
        if (d.open) {
          var a = d.animate([{ height: h0 + 'px' }, { height: s.offsetHeight + 'px' }], { duration: 340, easing: ease });
          a.onfinish = function () { d.open = false; d.style.overflow = ''; busy = false; };
        } else {
          d.open = true;
          var h1 = d.offsetHeight;
          var b = d.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 420, easing: ease });
          b.onfinish = function () { d.style.overflow = ''; busy = false; };
        }
      });
    });
  }

  /* ---------- intro curtain + page fade ---------- */
  function initIntro() {
    var intro = document.querySelector('.mkb-intro');
    if (!intro) return;
    var kill = function () { docEl.classList.remove('mkb-intro-on'); if (intro.parentNode) intro.parentNode.removeChild(intro); };
    if (docEl.classList.contains('mkb-intro-on') && !design) setTimeout(kill, 2400); else kill();
  }
  function initPageFade() {
    if (reduce || design) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.target === '_blank' || a.hasAttribute('download') || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
      var url; try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      if (a.closest('cart-drawer, quick-add-modal, .quick-add, .shopify-payment-button, form, .localization-form')) return;
      e.preventDefault();
      docEl.classList.add('mkb-leaving');
      setTimeout(function () { location.href = url.href; }, 300);
    });
    window.addEventListener('pageshow', function () { docEl.classList.remove('mkb-leaving'); });
  }

  /* ---------- init ---------- */
  function collect() {
    progItems = q(document, '[data-mkb-progress]');
    pxItems = q(document, '[data-mkb-parallax]');
    cta = document.querySelector('.mkb-sticky-cta');
    footer = document.querySelector('.footer, footer');
    bar = document.querySelector('.mkb-progress');
  }
  function init() {
    collect(); initHeader(); initReveals(document); initTilt(document); initMagnetic(document); initMouse(); initCursor(); initTickers(); initReels(); initWind(); initDetails(document); initPause(); initIntro(); initPageFade(); initLenis(); frame();
  }
  function rescan() { collect(); initHeader(); initReveals(document); initTilt(document); initMagnetic(document); initMouse(); initTickers(); initReels(); initWind(); initDetails(document); initPause(); frame(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);
  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:reorder', rescan);
  document.addEventListener('shopify:block:select', onScroll);
})();
